export default __webpack_public_path__ + "static/media/anthe-winner-trip.b5a448bb.png";